// extracted by mini-css-extract-plugin
module.exports = {"buttonLink":"+V3qX"};